import { useState, useCallback } from "react";
import { wrapperRequests } from "../../../services/api";

interface AutoPrintLinesCountResponse {
  totalLines: number;
}

export default function useAutoPrintLinesCount() {
  const [totalLines, setTotalLines] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLinesCount = useCallback(async (tagNames: string) => {
    setLoading(true);
    setError(null);

    try {
      const url = `products/auto-prints/count-labels-to-be-printed?tagNames=${tagNames}`;

      const response = await wrapperRequests<AutoPrintLinesCountResponse>(
        url,
        "GET",
      );

      setTotalLines(response.data.totalLines);
    } catch (err) {
      console.error("Error loading auto-print lines count:", err);
      setError("Error loading auto-print lines count");
      setTotalLines(0);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    totalLines,
    loading,
    error,
    fetchLinesCount,
  };
}
